import {wymsFetch, getParams} from '@/utils/fetch';

// 查询菜单树
export function queryModuleRolePermList(args) {
    const params = getParams(true, args);
    params.append('term', args.term);

    return wymsFetch({
        url: 'moduleRolePerm/queryModuleRolePermList',
        method: 'GET',
        params
    });
}

// 删除
export function deleteModuleRolePerm(args) {
    const params = getParams();
    params.append('ids', args.ids);

    return wymsFetch({
        url: 'moduleRolePerm/deleteModuleRolePerm',
        method: 'GET',
        params
    });
}

// 查询菜单根据应用id
export function queryModelByModuleId(args) {
    const params = getParams();
    params.append('moduleId', args.moduleId);

    return wymsFetch({
        url: 'moduleRolePerm/queryModelByModuleId',
        method: 'GET',
        params
    });
}

// 模块列表
export function queryModuleList() {
    const params = getParams();

    return wymsFetch({
        url: 'moduleRolePerm/queryModuleList',
        method: 'GET',
        params
    });
}

// 角色列表
export function queryRoleInfoList(args) {
    const params = getParams();
    params.append('systemType', args.systemType);

    return wymsFetch({
        url: 'moduleRolePerm/queryRoleInfoList',
        method: 'GET',
        params
    });
}
// 新增关系
export function insertModuleRolePerm(args) {
    const params = getParams();
    params.append('constantId', args.constantId);
    params.append('moduleId', args.moduleId);
    params.append('perList', args.perList);

    return wymsFetch({
        url: 'moduleRolePerm/insertModuleRolePerm',
        method: 'GET',
        params
    });
}
//查询已安装权限
export function queryByRoleModuleId(args) {
    const params = getParams();
    params.append('roleModuleId', args.roleModuleId);

    return wymsFetch({
        url: 'moduleRolePerm/queryByRoleModuleId',
        method: 'GET',
        params
    });
}

// 修改模块角色权限
export function updateModuleRolePerm(args) {
    const params = getParams();
    params.append('id', args.id);
    params.append('perList', args.perList);

    return wymsFetch({
        url: 'moduleRolePerm/updateModuleRolePerm',
        method: 'GET',
        params
    });
}



// WEBPACK FOOTER //
// ./src/api/moduleRolePermission.js